import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 采集端专用的定时遥控接口
 **********************************************************************************/
export default {
	/**
	 * 获取apk版本号
	 */
	createTimedControl: (deviceNo, parentArea, type, day, week, month,year, time, command, success, failure) => {
		Axios.post('/timedRemoteControl/createTimedControl.do', {
			deviceNo,
			parentArea,
			type,
			day,
			week,
			month,
			year,
			time,
			command
		}, success, failure);
	},
	updateTimedControl: (pkid, type, day, week, month,year, time, command, success, failure) => {
		Axios.post('/timedRemoteControl/updateTimedControl.do', {
			pkid,
			type,
			day,
			week,
			month,
			year,
			time,
			command
		}, success, failure);
	},
	deleteTimedControl: (pkid, success, failure) => {
		Axios.post('/timedRemoteControl/deleteTimedControl.do', {
			pkid
		}, success, failure);
	},
	/**
	 * 查询定时指令列表
	 */
	findListByDeviceNoAndParentArea: (deviceNo, parentArea, success, failure) => {
		Axios.post('/timedRemoteControl/findListByDeviceNoAndParentArea.do', {
			deviceNo, parentArea
		}, success, failure);
	}

}
